import { useQuery } from "@tanstack/react-query";
import { fetchPriceListingByProduct } from "../../Services/supplierQuotationsApi";

/**
 * Custom React Query hook for fetching price listing history for a product.
 *
 * @param {string|number} productId
 * @param {Object} [options] Additional React Query options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export const useProductPriceListing = (productId, options = {}) => {
  return useQuery({
    queryKey: ["priceListing", productId],
    queryFn: () => fetchPriceListingByProduct(productId),
    enabled: !!productId && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  });
};

export default useProductPriceListing;
